import React from 'react';

export const Separator = ({ className = '' }) => {
  return (
    <svg viewBox="0 0 8 24" className={`${className} fill-current stroke-current`}>
      <rect
        x="6.61523"
        y="0.327148"
        width="1"
        height="24"
        transform="rotate(16 6.61523 0.327148)"
      />
    </svg>
  );
};

export default Separator;
